<template>
  <div class="container">
    <BaseFrame
      submitText="提交"
      @submit='submit'
      clearText=""
      @cancel='$router.push(-1)'
      :idText="idText"
      :id="id"
      :infosArr="infoArray"
      :loadZIndex = true
    >
      <div slot="content">
          <div class="cardContainer">
            <lk-card>
              <div slot="title" class="lk-card-title">
                <span>商品价格调整</span>
                <!-- 先把多价格的入口去掉，后期可能再放开wxr -->
                <span class="lk-card-title_btn" v-if="isEdit && isMultiPrice" @click="toSinglePrice">切换至单价格模版</span>
                <!-- <span class="lk-card-title_btn" v-if="isEdit && !isMultiPrice" @click="toMultiPrice">切换至多价格模版</span> -->
                <span class="lk-card-title_btn" @click="addMultiPrice" v-if="isEdit && isMultiPrice">新增价格</span>
              </div>
              <!-- 单价格，编辑状态的'商品价格调整模块' -->
              <lk-form v-if="isEdit && !isMultiPrice" :model="singlePriceVersion" :label-width="150" label-postion="right" :rules="ruleValidate" ref="singlePriceVersion">
                <lk-row :gutter="16">
                  <lk-col span="10">
                    <lk-form-item label="本次调整销售单价：" prop="price">
                      <DtpInputNumber
                        :min="0"
                        :precision="6"
                        v-model="singlePriceVersion.price"
                        clearable
                        placeholder="请输入"
                        style="width: 100%;"
                        :frontDecimal='5'
                        :maxlength='12'
                        :ifNeedCheckAllNumber='true'
                        @on-change="priceInputChange">
                      </DtpInputNumber>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10">
                    <lk-form-item label="生效时间：" prop="effectTime">
                      <timeStampDatePicker v-model="singlePriceVersion.effectTime"></timeStampDatePicker>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter="16">
                  <lk-col span="10">
                    <lk-form-item label="调整幅度：">
                      <span>{{priceChangeExtent}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10">
                    <lk-form-item label="调整原因：" prop="adjustmentReason">
                      <lk-select v-model='singlePriceVersion.adjustmentReason' clearable>
                        <lk-option v-for="item in adjustmentReasonList" :key="item.id" :value="item.id">{{item.name}}</lk-option>
                      </lk-select>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter="16">
                  <lk-col span="10">
                    <lk-form-item label="有进价调整：" prop="priceAdjustment">
                      <lk-radio-group v-model='singlePriceVersion.priceAdjustment'>
                        <lk-radio :label='1'>是</lk-radio>
                        <lk-radio :label='2'>否</lk-radio>
                      </lk-radio-group>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10">
                    <lk-form-item label="最新进价：" prop="latestPrice" v-if="singlePriceVersion.priceAdjustment === 1">
                      <DtpInputNumber
                        :min="0"
                        :precision="2"
                        v-model="singlePriceVersion.latestPrice"
                        clearable
                        placeholder="请输入"
                        style="width: 100%;"
                      >
                      </DtpInputNumber>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter="16" v-if="isLowerPrice">
                  <lk-col span="10">
                    <lk-form-item label="价格补偿：" prop='priceCompensation'>
                      <lk-radio-group v-model='singlePriceVersion.priceCompensation'  @on-change='handleHaveCompensation'>
                        <lk-radio :label='1'>有</lk-radio>
                        <lk-radio :label='2'>无</lk-radio>
                      </lk-radio-group>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10" v-if="isShow">
                    <lk-form-item label="补偿时间：" prop="compensationTime">
                      <timeStampDatePicker v-model="singlePriceVersion.compensationTime"></timeStampDatePicker>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter="16" v-if="isLowerPrice && isShow">
                  <lk-col span="10">
                    <lk-form-item label="补偿形式：" prop='compensationForm'>
                      <lk-input v-model="singlePriceVersion.compensationForm" clerable :maxlength='40' placeholder='请输入'></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span="10">
                    <lk-form-item label="补偿协议：" prop='compensationAgreement'>
                      <Uploader :able='true' v-model.trim="singlePriceVersion.compensationAgreement"></Uploader>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter="16" v-if="isShow">
                  <lk-col span="20">
                    <lk-form-item label="预估返利说明：">
                      <lk-table border :columns="rebateColumns" :data="selectRebateList" v-if="!isMultiPrice"/>
                      <span class="addButton" @click="addNew">+新增供应商</span><br>
                      <span>返利计算规则填写示例：根据10月31日库存可销售数量30盒计算，每盒补偿1000元，合计补偿30000元</span>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
              <!-- 单价格，非编辑状态的'商品价格调整模块' -->
              <div v-if="!isEdit && !isMultiPrice" class="default-font">
                <!-- 当前销售价格：
                <span>{{priceVersion.price}}</span> -->
                <lk-form :label-width="150">
                  <lk-row v-for="item in singleTemShowData" :key="item.id">
                    <lk-col span="10" v-for="subItem in item.list" :key="subItem.id">
                      <lk-form-item :label="`${subItem.title}：`">
                        <Uploader v-if="subItem.isUploader" :able="false" v-model="priceVersion[subItem.key]" ></Uploader>
                        <span v-else>{{priceVersion[subItem.key]}}</span>
                      </lk-form-item>
                    </lk-col>
                  </lk-row>
                  <lk-row :gutter="16" v-if="this.showRebateData.length > 0">
                    <lk-col span="20">
                      <lk-form-item label="预估返利明细：">
                        <lk-table border :columns="showRebateColumns" :data="showRebateData"/>
                      </lk-form-item>
                    </lk-col>
                </lk-row>
                </lk-form>
              </div>
              <!-- 多价格-->
              <lk-table
                v-if="isMultiPrice"
                border
                :columns="isEdit ? multiPriceColumns : readyOnlyMultiPriceColumns"
                :data="multiPriceData"
              />
              <lk-form ref="mutiForm" v-if="isMultiPrice&&isEdit" :rules="multiRuleValidate" :model="multiPriceVersion" :label-width="80">
                <lk-row :gutter="16">
                  <lk-col span="10">
                    <lk-form-item label="调整原因：" prop="modifiedReason" class="multi-from-item">
                      <lk-input :maxlength='100' type="textarea" v-model.trim="multiPriceVersion.modifiedReason"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
              <lk-form :label-width="labelWidth" v-if='isEdit'>
                <lk-row :gutter="16">
                  <lk-col span="10">
                    <lk-form-item label="审批单附件：" prop=''>
                      <Attachment
                        :uploadInfo='uploadInfo'
                        @attachmentConfirm='attachmentConfirm'
                      >
                      </Attachment>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </lk-card>
          </div>

        <div class="cardContainer">
          <lk-card title="价格调整记录">
            <!-- 单价格模版 价格调整记录 -->
            <lk-table border :columns="columns" :data="tableData" v-if="!isMultiPrice"/>
            <!-- 多价格模版 价格调整记录 -->
            <lk-table border :columns="multiPriceChangeColumns" :data="multiChangeData" v-else/>
          </lk-card>
        </div>
      </div>
    </BaseFrame>
  </div>
</template>
<script>
import _ from 'lodash';
import BaseFrame from '../../components/frame/BaseFrame.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';
import DtpInputNumber from '../../components/DtpInputNumber';
import Uploader from '../../components/Uploader.vue';
import citySelect from '../../components/citySelect';
import sharedDara from '../../libs/sharedDara';
import Attachment from '../../components/purchase/Attachment';

export default {
  name: 'createPriceVersion',
  components: {
    BaseFrame,
    DtpInputNumber,
    Uploader,
    Attachment,
  },
  data() {
    return {
      goodsStoreId: 0,
      uploadInfo: [
        {
          appendixName: '',
          appendixUrl: '',
        },
      ],
      singleTemShowData: [
        {
          id: 1,
          list: [
            {
              id: 11,
              key: 'price',
              title: '本次调整销售单价',
            },
            {
              id: 12,
              key: 'effectTimeStr',
              title: '生效时间',
            },
          ],
        },
        {
          id: 2,
          list: [
            {
              id: 21,
              key: 'adjustmentRangeStr',
              title: '调整幅度',
            },
            {
              id: 22,
              key: 'adjustmentReasonName',
              title: '调整原因',
            },
          ],
        },
        {
          id: 3,
          list: [
            {
              id: 31,
              key: 'priceAdjustmentName',
              title: '有进价调整',
            },
            {
              id: 32,
              key: 'latestPrice',
              title: '最新进价',
            },
          ],
        },
        {
          id: 4,
          list: [
            {
              id: 41,
              key: 'priceCompensationName',
              title: '价格补偿',
            },
            {
              id: 42,
              key: 'compensationTimeStr',
              title: '补偿时间',
            },
          ],
        },
        {
          id: 5,
          list: [
            {
              id: 51,
              key: 'compensationForm',
              title: '补偿形式',
            },
            {
              id: 52,
              key: 'compensationAgreement',
              title: '补偿协议',
              isUploader: true,
            },
          ],
        },
      ],
      idText: '',
      id: '',
      infoArray: [],
      disablePage: true,
      priceVersion: {},
      columns: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, params) => h(
            'span',
            `${params.index + 1}`,
          ),
        },
        { title: '调整前价格', key: 'beforeSalePrice', minWidth: 116 },
        { title: '调整后价格', key: 'price', minWidth: 116 },
        // 审批状态， 操作， 操作人， 操作时间
        { title: '调整原因', key: 'adjustmentReasonName', minWidth: 116 },
        { title: '生效时间', key: 'effectTimeStr', minWidth: 116 },
        { title: '价格补偿', key: 'priceCompensationName', minWidth: 116 },
        { title: '补偿时间', key: 'compensationTimeStr', minWidth: 116 },
        {
          title: '补偿协议',
          minWidth: 166,
          render: (h, params) => h(
            Uploader,
            {
              props: {
                url: params.row.compensationAgreement,
              },
            },
          ),
        },
        { title: '创建人', key: 'createUserName', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
      ],
      tableData: [],
      ruleValidate: {
        price: [
          {
            required: true, message: '请输入价格', trigger: 'change', type: 'number',
          },
          // { validator: priceTwoDecimal, trigger: 'blur' },
        ],
        adjustmentReason: [
          {
            required: true, message: '请选择调整原因', trigger: 'change', type: 'number',
          },
        ],
        effectTime: [
          {
            required: true, trigger: 'change', type: 'number', validator: utils.validate.greaterThanToday,
          },
        ],
        priceAdjustment: [
          {
            required: true, message: '请选择', trigger: 'change', type: 'number',
          },
        ],
        latestPrice: [
          {
            required: true, message: '请输入最新进价', type: 'number',
          },
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                callback(new Error('最新进价不能为0'));
              } else {
                callback();
              }
            },
            trigger: 'change',
          },
        ],
        priceCompensation: [
          {
            required: true, message: '请选择', trigger: 'change', type: 'number',
          },
        ],
        compensationTime: [
          {
            required: true, message: '请选择补偿时间', trigger: 'change', type: 'number', validator: utils.validate.greaterThanToday,
          },
        ],
        compensationForm: [
          {
            required: true, message: '请输入补偿形式', trigger: 'change',
          },
        ],
        compensationAgreement: [
          {
            required: true, message: '请上传补偿协议', trigger: 'change',
          },
        ],
      },
      adjustmentReasonList: [],
      rebateColumns: [
        {
          title: '供应商名称',
          minWidth: 200,
          align: 'center',
          key: 'supplierName',
          renderHeader: (h, params) => {
            return h('div', [
              h('span', { style: { color: "#ed4014", marginLeft: '4px' } }, '*'),
              h('span', '供应商名称'),
            ]);
          },
          render: (h, { row, index }) => {
            const optionArr = this.rebateVoList.map(item => h('lk-option', {
              props: {
                value: item.supplierStoreId,
              },
            }, item.supplierName));
            return h('div', [
              h('lk-select',
                {
                  on: {
                    'on-change': (value) => {
                      this.selectEvent(index, value);
                    },
                  },
                  props: {
                    value: row.supplierStoreId,
                    placeholder: '请选择',
                    transfer: true,
                    multiple: false,
                    filterable: true,
                  },
                },
                optionArr)]);
          },
        },
        {
          title: '预估返利(元)',
          key: 'estimateAmount',
          width: 116,
          renderHeader: (h, params) => {
            return h('div', [
              h('span', { style: { color: "#ed4014", marginLeft: '4px' } }, '*'),
              h('span', '预估返利(元)'),
            ]);
          },
          render: (h, params) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.selectRebateList[params.index].estimateAmount = e.target.value;
              },
            },
            props: {
              maxlength: 10,
              number: true,
              value: params.row.estimateAmount,
            },
          }),
        },
        {
          title: '返利计算规则',
          width: 200,
          key: 'rebateRule',
          renderHeader: (h, params) => {
            return h('div', [
              h('span', { style: { color: "#ed4014", marginLeft: '4px' } }, '*'),
              h('span', '返利计算规则'),
            ]);
          },
          render: (h, params) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.selectRebateList[params.index].rebateRule = e.target.value;
              },
            },
            props: {
              maxlength: 100,
              value: params.row.rebateRule,
            },
          }),
        },
        {
          title: '备注',
          key: 'remark',
          width: 200,
          renderHeader: (h, params) => {
            return h('div', [
              h('span', '备注'),
            ]);
          },
          render: (h, params) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                this.selectRebateList[params.index].remark = e.target.value;
              },
            },
            props: {
              maxlength: 100,
              value: params.row.remark,
            },
          }),
        },
        { title: '在途冻结数量', key: 'transportingNum', minWidth: 116 },
        { title: '系统冻结数量', key: 'sysFrozenNum', minWidth: 116 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 116 },
        { title: '可销售数量', key: 'num', minWidth: 116 },
        { title: '库存总数量', key: 'totalNum', minWidth: 116 },
        {
          title: '操作',
          width: 60,
          fixed: 'right',
          render: (h, { row }) => h('div', [
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
              },
              on: {
                click: () => {
                  this.rebateRemove(row.supplierStoreId);
                },
              },
            }, '删除'),
          ]),
        },
      ],
      rebateVoList: [], // 原数据
      selectRebateList: [],
      showRebateColumns: [
        { title: '供应商名称', minWidth: 200, key: 'supplierName' },
        { title: '预估返利(元)', width: 116, key: 'estimateAmount' },
        { title: '返利计算规则', width: 200, key: 'rebateRule' },
        { title: '备注', width: 200, key: 'remark' },
        { title: '在途冻结数量', key: 'transportingNum', minWidth: 116 },
        { title: '系统冻结数量', key: 'sysFrozenNum', minWidth: 116 },
        { title: '手动冻结数量', key: 'manualFrozenNum', minWidth: 116 },
        { title: '可销售数量', key: 'num', minWidth: 116 },
        { title: '库存总数量', key: 'totalNum', minWidth: 116 },
      ],
      showRebateData: [],
      originIsMultiPrice: false, // 初始化时 是否为多价格模版
      isMultiPrice: false, // 是否为多价格模版
      // 只读的多价格模版table columns
      readyOnlyMultiPriceColumns: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, params) => h(
            'span',
            `${params.index + 1}`,
          ),
        },
        {
          title: '价格',
          key: 'price',
          minWidth: 116,
        },
        {
          title: '应用范围',
          key: 'rangeNames',
          minWidth: 160,
          render: (h, params) => h(
            'span',
            params.index === 0 ? '默认' : params.row.rangeNames.join('，'),
          ),
        },
        {
          title: '备注',
          key: 'remark',
          minWidth: 160,
        },
      ],
      multiPriceColumns: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, params) => h(
            'span',
            `${params.index + 1}`,
          ),
        },
        {
          title: '价格',
          minWidth: 116,
          render: (h, params) => h('lk-input-number',
            {
              props: {
                value: params.row.price,
                min: 0,
                max: 9999999999.99,
                precision: 6,
                step: 0.000001,
                activeChange: false,
              },
              on: {
                input: (e) => {
                  params.row.price = e;
                  this.multiPriceData[params.index] = params.row; // https://github.com/iview/iview/issues/1781
                },
              },
            }),
        },
        {
          title: '应用范围',
          minWidth: 160,
          render: (h, params) => (params.index ? h(
            citySelect, // 自定义组件这里不需要加引号
            {
              props: {
                list: this.cityList,
                disableIds: this.disableCitys,
                value: params.row.range,
              },
              on: {
                input: (e) => {
                  params.row.range = e;
                  this.multiPriceData.splice(params.index, 1, params.row);
                },
              },
            },
          ) : h('span', '默认')),
        },
        {
          title: '备注',
          minWidth: 160,
          render: (h, params) => (params.index ? h(
            'lk-input',
            {
              class: 'default-font',
              props: {
                type: 'textarea',
                value: params.row.remark,
                maxlength: 25,
              },
              on: {
                input: (e) => {
                  params.row.remark = e;
                  this.multiPriceData[params.index] = params.row;
                },
              },
            },
          ) : h('span', '默认价格')),
        },
        {
          title: '操作',
          minWidth: 80,
          render: (h, params) => h(
            'div',
            [
              h('lk-button', {
                props: {
                  type: 'text',
                  size: 'small',
                  disabled: params.index === 0,
                },
                on: {
                  click: () => {
                    this.multiPriceData.splice(params.index, 1);
                  },
                },
              }, '删除'),
            ],
          ),
        },
      ],
      multiPriceData: [],
      multiRuleValidate: {
        modifiedReason: [
          {
            required: true, message: '请输入原因', trigger: 'blur',
          },
        ],
      },
      // 多价格调整记录 表格
      multiPriceChangeColumns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => this.multiPriceChangeChildrenColumns && this.multiPriceChangeChildrenColumns.length && h(
            'lk-table',
            {
              props: {
                border: true,
                columns: this.multiPriceChangeChildrenColumns,
                data: params.row.salePriceCityHistoryList,
              },
            },
          ),
        },
        {
          title: '序号',
          minWidth: 116,
          render: (h, params) => h(
            'span',
            `${params.index + 1}`,
          ),
        },
        { title: '审批状态', key: 'statusApproval', minWidth: 116 },
        { title: '调整原因', key: 'modifiedReason', minWidth: 140 },
        { title: '操作', key: 'operate', minWidth: 116 },
        { title: '操作人', key: 'createUserName', minWidth: 116 },
        { title: '操作时间', key: 'createTime', minWidth: 116 },
      ],
      // // 多价格调整记录 子表格
      multiPriceChangeChildrenColumns: [
        {
          title: '序号',
          minWidth: 80,
          render: (h, params) => h(
            'span',
            params.index + 1,
          ),
        },
        {
          title: '应用范围',
          key: 'cityName',
          minWidth: 250,
        },
        {
          title: '调整前价格',
          minWidth: 116,
          render: (h, params) => h(
            'span',
            utils.isEmpty(params.row.oldPrice) ? '-' : params.row.oldPrice,
          ),
        },
        { title: '操作', key: 'operateName', minWidth: 116 },
        {
          title: '调整后价格',
          minWidth: 116,
          render: (h, params) => h(
            'span',
            utils.isEmpty(params.row.newPrice) ? '-' : params.row.newPrice,
          ),
        },
        {
          title: '价格备注',
          minWidth: 116,
          render: (h, params) => h(
            'span',
            utils.isEmpty(params.row.remark) ? '-' : params.row.remark,
          ),
        },

      ],
      multiChangeData: [],
      // 审批状态映射 审批状态 1 审批中 2 审批通过 3 审批驳回
      statusApprovalArry: Object.freeze([
        '-',
        '审批中',
        '审批通过',
        '审批驳回',
      ]),
      cityList: [], // 城市选择器数据 [{label, value, children: [{label, value, children}]}]
      singlePriceVersion: {
        price: null,
        modifiedReason: '',
      },
      multiPriceVersion: {
        modifiedReason: '',
      },
    };
  },
  watch: {
    'singlePriceVersion.priceCompensation': {
      handler() {
        this.singlePriceVersion.compensationTime = null;
        this.singlePriceVersion.compensationForm = null;
      },
    },
    'singlePriceVersion.priceAdjustment': {
      handler() {
        this.singlePriceVersion.latestPrice = null;
      },
    },
  },
  computed: {
    labelWidth() {
      return this.isMultiPrice ? 90 : 150;
    },
    isEdit() {
      return this.$route.meta.isEdit;
    },
    disableCitys() {
      const disableArr = [];
      this.multiPriceData.forEach((item) => {
        if (item.range && item.range.length) {
          disableArr.push(...item.range);
        }
      });
      return disableArr;
    },
    isLowerPrice() {
      if (!this.singlePriceVersion.price && this.singlePriceVersion.price !== 0) {
        return false;
      }
      if (this.singlePriceVersion.price < this.priceVersion.oldPrice) {
        return true;
      }
      return false;
    },
    priceChangeExtent() {
      if (this.priceVersion.oldPrice === 0) {
        return '-';
      }
      if (!this.singlePriceVersion.price && this.singlePriceVersion.price !== 0) {
        return '';
      }
      if (!this.priceVersion.oldPrice && this.priceVersion.oldPrice != 0) {
        return '';
      }
      const value = (this.singlePriceVersion.price * 1000000 - this.priceVersion.oldPrice * 1000000) / (this.priceVersion.oldPrice * 1000000);
      return `${(value * 100).toFixed(2)}%`;
    },
    isShow() {
      return this.singlePriceVersion.priceCompensation === 1; // 1有 2无
    },
  },
  methods: {
    priceInputChange() {
      if (!this.isLowerPrice) { // 不展示价格补偿清空数据
        this.selectRebateList = [];
      }
    },
    handleHaveCompensation(val) {
      if (val == 2) { // 不展示价格补偿清空数据
        this.selectRebateList = [];
      } else {
        this.getCompanyList();
      }
    },
    checkRebateInfo() {
      let isPass = true;
      for (let i = 0; i < this.selectRebateList.length; i++) {
        if (!this.selectRebateList[i].estimateAmount) {
          isPass = false;
          this.$Message.error('预估返利不可为空，请输入返利金额或删除对应明细');
          break;
        }
        if (this.selectRebateList[i].estimateAmount * 1 <= 0) {
          isPass = false;
          this.$Message.error('预估返利需大于0，请输入返利金额或删除对应明细');
          break;
        }
        if (!_.isFinite(Number(this.selectRebateList[i].estimateAmount))) {
          isPass = false;
          this.$Message.error('请输入正确格式返利金额或删除对应明细');
          break;
        }
        const tempStr = this.clearBlank(this.selectRebateList[i].rebateRule);
        if (this.selectRebateList[i].rebateRule == '' || !this.selectRebateList[i].rebateRule || tempStr == '' || !tempStr) {
          isPass = false;
          this.$Message.error('请填写返利计算规则');
          break;
        }
      }
      return isPass;
    },
    clearBlank(value) {
      if (value) {
        value = value.replace(/\s/g, '');
      }
      return value;
    },
    selectEvent(index, value) {
      if (value == this.selectRebateList[index].supplierStoreId) {
        return;
      }
      const hasIndex = this.selectRebateList.findIndex(fItem => fItem.supplierStoreId == value);
      if (hasIndex >= 0) {
        this.$Message.error('该供应商已被选');
        const beforeIndex = this.rebateVoList.findIndex(fItem => fItem.supplierStoreId == this.selectRebateList[index].supplierStoreId);
        const tempList = utils.deepClone(this.selectRebateList);
        tempList[index].supplierName = this.rebateVoList[beforeIndex].supplierName;
        this.selectRebateList = tempList;
        return;
      }
      const tempList = utils.deepClone(this.selectRebateList);
      const fIndex = this.rebateVoList.findIndex(fItem => fItem.supplierStoreId == value);
      tempList[index] = this.rebateVoList[fIndex];
      this.selectRebateList = tempList;
    },
    configRebateList() {
      const tempList = utils.deepClone(this.rebateVoList);
      this.selectRebateList = tempList.filter(item => item.defaultFlag);
    },
    addNew() {
      const newData = {
        supplierStoreId: 0,
        supplierName: '',
        supplierCode: '',
        estimateAmount: 0,
        transportingNum: 0,
        sysFrozenNum: 0,
        manualFrozenNum: 0,
        num: 0,
        totalNum: 0,
        rebateRule: '',
        remark: '',
        defaultFlag: true,
      };
      this.selectRebateList.push(newData);
    },
    rebateRemove(supplierStoreId) {
      const beforeIndex = this.rebateVoList.findIndex(fItem => fItem.supplierStoreId == supplierStoreId);
      if (beforeIndex >= 0) {
        this.rebateVoList[beforeIndex].defaultFlag = false;
      }
      const removeIndex = this.selectRebateList.findIndex(fItem => fItem.supplierStoreId == supplierStoreId);
      if (removeIndex >= 0) {
        this.selectRebateList.splice(removeIndex, 1);
      }
    },
    attachmentConfirm(val) {
      this.uploadInfo = val;
    },
    getFormData(id) {
      return new Promise((resolve) => {
        sale.listPriceOne({ id }).then((res) => {
          if (res.data.status === 200) {
            this.priceVersion = res.data.data.salePriceVersion;
            if (this.priceVersion.hasOwnProperty('rebateVoList')) {
              this.showRebateData = this.priceVersion.rebateVoList;
            }
            this.transformSomeFields(this.priceVersion);
            const { data } = res.data;
            // 是否是多价格模版
            this.isMultiPrice = !!this.priceVersion.salePriceCityRelList && this.priceVersion.salePriceCityRelList.length > 1;
            this.originIsMultiPrice = this.isMultiPrice;
            if (this.priceVersion.priceAdjustment === 2 || !this.priceVersion.priceAdjustment) {
              // 当价格调整为否或者字段为空，隐藏“最近进价（新采购单价）”字段
              this.priceVersion.priceAdjustmentName = '无';
              const tempList = this.singleTemShowData.map((item) => {
                if (item.id === 3) {
                  const tempItem = item.list.filter(subItem => subItem.id !== 32);
                  item.list = tempItem;
                }
                return item;
              });
              this.singleTemShowData = tempList;
            } else if (this.priceVersion.priceAdjustment === 1) {
              // 有进价调整，显示'有'
              this.priceVersion.priceAdjustmentName = '有';
            }
            if (this.priceVersion.priceCompensation === 2) {
              // 价格补偿选无时，价格补偿字段展示为“无”，隐藏“补偿时间”、“补偿方式”、“补偿协议”字段
              this.priceVersion.priceCompensationName = '无';
              const tempList = this.singleTemShowData.map((item) => {
                if (item.id === 4) {
                  const tempItem = item.list.filter(subItem => subItem.id !== 42);
                  item.list = tempItem;
                }
                if (item.id === 5) {
                  const tempItem = item.list.filter(subItem => subItem.id !== 5);
                  item = tempItem;
                }
                return item;
              });
              this.singleTemShowData = tempList;
            } else if (!this.priceVersion.priceCompensation) {
              // 当价格补偿字段为空，隐藏“补偿时间”、“补偿方式”、“补偿协议”字段
              this.priceVersion.priceCompensationName = '无';
              const tempList = this.singleTemShowData.filter(item => item.id !== 4 && item.id !== 5);
              this.singleTemShowData = tempList;
            }
            this.goodsStoreId = res.data.data.goodsStoreId;
            if (this.isMultiPrice) {
              // 多价格回填表格内容
              this.multiPriceData = [...data.salePriceVersion.salePriceCityRelList];
              this.singlePriceVersion.price = data.salePriceVersion.salePriceCityRelList[0].price;
            }
            this.idText = '商品通用名';
            this.id = this.priceVersion.approvedDrugNames;
            this.infoArray.push(
              { name: '商品ID:', value: this.priceVersion.goodsStoreId },
              { name: '商品编码:', value: this.priceVersion.drugSerialCode },
              { name: '规格:', value: this.priceVersion.specifications },
              { name: '批准文号/器械注册（备案）证号:', value: data.approvalCode },
              { name: '生产厂家:', value: data.salePriceVersion.manufacturer },
              { name: '产地:', value: data.origin },
            );
            this.priceVersion.oldPrice = this.priceVersion.price;
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getData(id) {
      sale
        .listPriceRecord({ id })
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            let number = 1;
            res.data.data.forEach((item) => {
              const result = {};
              utils.exchangeTableCustom(item, result);
              if (result.compensationAgreement === '-') {
                result.compensationAgreement = '';
              }
              result.number = number++;
              // result.price =  utils.exchangePercent(result.price);
              result.createTime = utils.exchangeTimeToSecond(result.createTime);
              this.transformSomeFields(result);
              // 审批状态 1 审批中 2 审批通过 3 审批驳回
              if (result.statusApproval && result.statusApproval < 4) {
                result.statusApproval = this.statusApprovalArry[result.statusApproval];
              } else {
                result.statusApproval = '';
              }
              // result.loading = false;
              // 多价格记录
              if (result.salePriceCityHistoryList && result.salePriceCityHistoryList.length) {
                result.salePriceCityHistoryList.forEach((hItem) => {
                  // 处理空数据 与 应用范围数据
                  Object.keys(hItem).forEach((hItemKey) => {
                    if (utils.isEmpty(hItem[hItemKey])) {
                      hItem[hItemKey] = '-';
                    }
                  });
                });
                this.multiChangeData.push(result);
              } else {
                // 单价格记录
                this.tableData.push(result);
              }
            });
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getCompanyList() {
      sale.getCompanyList({ goodsStoreId: this.goodsStoreId, storeId: this.$store.state.storeInfo.id }).then((res) => {
        if (res.data.status === 200) {
          this.rebateVoList = res.data.data;
          this.configRebateList();
        }
      });
    },
    transformSomeFields(obj) {
      if (obj.adjustmentReason) {
        obj.adjustmentReasonName = this.adjustmentReasonList[obj.adjustmentReason - 1].name;
      }
    },
    cancel() {
      this.$router.go(-1);
    },
    submit() {
      if (!this.checkRebateInfo()) {
        return;
      }
      // 多价格
      const params = {};
      if (this.isMultiPrice) {
        const originSalePriceCityRelList = this.priceVersion.salePriceCityRelList ? this.priceVersion.salePriceCityRelList : [];
        // 多价格校验
        if (!this.validateMultiPrice(this.multiPriceData, originSalePriceCityRelList)) {
          return false;
        }
        // 多价格 价格调整只有一条数据时，当做单价格处理；
        if (this.multiPriceData.length === 1) {
          this.$Message.error('仅有一条价格，请切换至单价格模版提交');
          return;
        }
        // 多价格 多条数据
        const temp = {};
        temp.salePriceCityRelList = [...this.multiPriceData];
        temp.salePriceCityRelList[0].range = [0]; // 第一行无法选择应用范围，传[0]
        // temp.salePriceCityRelList[0].rangeNames = ['默认'];
        temp.modifiedReason = this.multiPriceVersion.modifiedReason;
        // 多价格 提交数据与原始数据比对
        if (this.compareMultiPrice(this.multiPriceData, this.priceVersion.salePriceCityRelList)) {
          this.$Message.error('本次提交价格无调整！');
        } else {
          temp.salePriceCityRelList.forEach((item) => {
            delete item.rangeNames;
          });
          Object.assign(params, this.priceVersion, temp);
        }
      } else {
        // 单价格处理
        this.$refs.singlePriceVersion.validate((valid) => {
          if (valid) {
            if (!this.originIsMultiPrice && this.singlePriceVersion.price === this.priceVersion.price) {
              // this.gotoList();
              this.$Message.error('本次提交价格无调整！');
            } else {
              if (this.singlePriceVersion.priceCompensation && this.singlePriceVersion.priceCompensation === 2) {
                this.singlePriceVersion.compensationTime = null;
                this.singlePriceVersion.compensationForm = null;
                this.singlePriceVersion.compensationAgreement = null;
              }
              Object.assign(params, this.priceVersion, this.singlePriceVersion);
              params.salePriceCityRelList && (delete params.salePriceCityRelList);
            }
            params.bizExtraVos = this.uploadInfo.some(item => item.appendixName === '' || item.appendixUrl === '') ? [{}] : this.uploadInfo;
          } else {
            this.$Message.error('请按照要求填写');
            return false;
          }
        });
      }
      if (Object.keys(params) && Object.keys(params).length) {
        params.rebateVoList = this.selectRebateList;
        this.createPrice(params);
      }
    },
    // 多价格数据校验 1、校验数据格式是否符合要求 2.校验与上次调整内容是否相同
    validateMultiPrice(arr) {
      let r = true;
      if (!arr || !arr.length) {
        this.$Message.error('多价格模版，请至少添加一条价格调整信息');
        return false;
      }
      // 价格 与 应用范围为必填项
      arr.forEach((item, index) => {
        if (utils.isEmpty(item.price)) {
          r = false;
          this.$Message.error(`第${index + 1}行，价格信息缺失，请完善！`);
        }
        if (index !== 0 && (!item.range || !item.range.length)) {
          r = false;
          this.$Message.error(`第${index + 1}行，应用范围信息缺失，请完善！`);
        }
      });
      // 调整原因
      if (utils.isEmpty(this.multiPriceVersion.modifiedReason)) {
        r = false;
        this.$Message.error('请填写调整原因！');
      }
      return r;
    },
    // 多价格数据对比
    compareMultiPrice(multiPriceData, originMultiPriceData) {
      if (!originMultiPriceData || multiPriceData.length !== originMultiPriceData.length) {
        return false;
      }
      // 多价格数据一致性进行对比, 以应用范围为key进行对比，价格存在相同的
      let r = true;
      for (let index = 0; index < multiPriceData.length; index++) {
        if (index === 0 && multiPriceData[0].price !== originMultiPriceData[0].price) {
          r = false;
          return;
        }
        if (index !== 0) {
          const range = multiPriceData[index].range;
          const oIndex = originMultiPriceData.findIndex((fItem) => {
            const fRange = fItem.range;
            return range.length === fRange.length && _.difference(range, fRange).length === 0;
          });
          if (oIndex === -1) {
            r = false;
            return;
          }
          if (multiPriceData[index].price !== originMultiPriceData[oIndex].price) {
            r = false;
            return;
          }
          if (multiPriceData[index].remark !== originMultiPriceData[oIndex].remark) {
            r = false;
            return;
          }
        }
      }
      return r;
    },
    gotoList() {
      this.$router.push({ name: 'priceList' });
    },
    createPrice(params) {
      sale.createPrice(params).then((res) => {
        if (res.data.status === 200) {
          this.gotoList();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toSinglePrice() {
      this.isMultiPrice = false;
    },
    toMultiPrice() {
      this.isMultiPrice = true;
      if (!this.multiPriceData.length) {
        const price = this.priceVersion.price;
        this.multiPriceData.push({
          price,
          range: [],
          remark: '默认价格',
        });
      }
    },
    addMultiPrice() {
      this.multiPriceData.push({
        price: null,
        range: [],
        // rangeNames: '',
        remark: '',
      });
    },
  },
  created() {
    if (this.isEdit) {
      sale.getCitys().then((res) => {
        if (res.data.status === 200) {
          this.cityList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    }
    this.adjustmentReasonList = sharedDara.adjustmentReasonList;
  },
  mounted() {
    const { id } = this.$route.params;
    this.getFormData(id);
    this.getData(id);
  },
};
</script>
<style lang="less" scoped>
@import '~iview/src/styles/index.less';
.cardContainer {
  margin-bottom: 16px;
}
.default-font {
  font-size: 12px;
}
/deep/ textarea.ivu-input {
  font-size: inherit;
}
.lk-card-title {
  height: 33px;
  line-height: 33px;
  font-size: 12px;
  color: #17233d;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .lk-card-title_btn {
    margin-left: 25px;
    color: @primary-color;
    cursor: pointer;
  }
}
.multi-from-item {
  margin-top: 12px;
  margin-bottom: 8px;
  font-weight: bold;
}
.addButton {
  font-weight: 500;
  color: #2d8cf0;;
}
</style>
